module.exports = __webpack_public_path__ + "static/BadKunoichiDX-d978082eade91fc92f237ad01663c62a.png";